






































import Vue from 'vue'

import AppForm from '@/components/app/AppForm.vue'

export default Vue.extend({
  name: "ResourceCreate",
  components: { AppForm, ResourceCreate: {} },
  props: {
    related: {
      type: Boolean,
      default: false
    },
    resource: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      createRelated: false,
      fields: [] as FormField[],
      id: null,
      relatable: {},
      schema: [] as any[]
    }
  },

  methods: {
    createdRelated(result) {
      this.fields[this.fields.findIndex(field => field.key == result.resource)].value.push(result.id)
      this.relatable[result.resource].push(result.data)
      this.createRelated = false
    },
    async initData() {
      this.schema = await this.getSchema()
      this.initFields()
      this.schema.filter(field => field.display == "relationship").forEach(field => {
        this.$set(this.relatable, field.key, this.$_data[field.key].data)
      })
    },
    async initFields() {
      this.fields = this.schema.map(field => Object.assign(field, {value: field.defaultValue}))
    },
    async getSchema() {
      const schema = await this.$schema.get(this.resource)
      return schema
    },
    showCreateRelated(resource) {
      this.createRelated = resource
    },
    async submit(data) {
      try {
        const result = await this.$api.create(this.resource, data)
        this.success({...result, data})
        if (!this.related) {
          const createAnother = confirm("Do you want to create another new item?")
          createAnother ? this.$router.go(0) : this.$router.push(`/${this.resource}/${result.id}`)
        }
      } catch (err) {
        window.console.log(err)
        alert("Something went wrong!")
      }
    },
    success(result) {
      alert(result.message)
      this.$emit('success', {action: "create", data: {...result.data, _id: result.id}, id: result.id, resource: this.resource})
    }
  },

  beforeCreate() {
    // @ts-ignore
    this.$options.components.ResourceCreate = require('./ResourceCreate.vue').default
  },

  async created() {
    this.initData()
  }
})
